/* eslint-disable sort-keys */
import { Icon } from '@clientbase/clientbase-library'
import { Box, Tooltip, Typography } from '@mui/material'
import { DataService } from 'api/DataService'
import moment from 'moment'

import { ButtonRounded } from 'components/button'

import { getReportTypeLabel } from 'utils/reports/reportTypeLabels'

import { theme } from 'styles/theme'

import { renderFilters } from './filterDictionary'
import { ReportFilterEntry, ReportResponse } from './index'
import * as S from './styles'

const statusMapper: Record<string, string> = {
  pending: 'Pendente',
  processing: 'Processando',
  generating: 'Processando',
  generated: 'Disponível',
  error: 'Erro'
}

const documentViewed = async (uuid: string) => {
  const resp = await DataService({
    type: 'POST',
    url: `/v1/reports/${uuid}/downloaded`
  })
  return resp
}

const handleDownload = async (uuid: string) => {
  try {
    const resp = await DataService({
      type: 'GET',
      url: `/v1/reports/${uuid}/excel`
    })
    const data = await resp.data

    window.open(data.record.url, '_blank')
  } catch (err) {
    return
  }
  documentViewed(uuid)
}

export const createDataTable = (
  downloaded: boolean,
  uuid: string,
  type: string,
  due_date: Date,
  status: string,
  filtersParsed?: ReportFilterEntry[]
) => {
  const date = moment(due_date).format('DD/MM/YYYY HH:mm')
  const filtersNode = renderFilters(filtersParsed)

  return {
    type: (
      <S.NotifyWrapper>
        {downloaded || status === 'error' ? (
          <S.Separator />
        ) : (
          <div>
            <S.Notify notViewed={true} />
          </div>
        )}
        <Box display="flex" flexDirection="column" minWidth={0}>
          <S.StatusText>{getReportTypeLabel(type)}</S.StatusText>
          {filtersNode && (
            <Tooltip title={filtersNode} enterTouchDelay={0} arrow>
              <Typography
                variant="xsLight"
                sx={{
                  color: 'neutral.400',
                  fontSize: '12px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  maxWidth: '700px',
                  display: 'block'
                }}
              >
                {filtersNode}
              </Typography>
            </Tooltip>
          )}
        </Box>
      </S.NotifyWrapper>
    ),
    date,
    status: (
      <S.StatusChip status={status}>
        {statusMapper[status] || 'Desconhecido'}
      </S.StatusChip>
    ),
    actions: (
      <Box>
        <ButtonRounded
          onClick={() => handleDownload(uuid)}
          variant="transparent"
          disabled={status !== 'generated'}
        >
          <Icon
            icon="download"
            sx={{
              color:
                status === 'generated'
                  ? theme.palette.neutral[200]
                  : theme.palette.neutral[700]
            }}
          />
        </ButtonRounded>
      </Box>
    )
  }
}

export const convertToRows = (reports: ReportResponse[]) =>
  reports?.map((report: ReportResponse) => {
    if (!report) return {}

    return createDataTable(
      report.downloaded,
      report.uuid,
      report.model,
      report.created_at,
      report.status,
      report.filters_parsed
    )
  })
